// Обработчики UI событий
// Направление: server -> client
import emitter from "../../core/wsEmitter";
import uiService from "../../services/ui.service";

emitter.on("ui.freeze", (data: any) => {
	console.log("ui freeze", data);
	uiService.handleFreeze();
});

emitter.on("ui.unfreeze", (data: any) => {
	console.log("ui unfreeze", data);
	uiService.handleUnfreeze();
});
